import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ref, onMounted } from 'vue';

export const useServices = () => {
  const wrapperRef = ref<HTMLElement | null>(null);
  const isModalOpen = ref(false);

  gsap.registerPlugin(ScrollTrigger);

  const openModal = () => {
    isModalOpen.value = true;
  };

  const closeModal = () => {
    isModalOpen.value = false;
  };

  const initAnimation = () => {
    if (!wrapperRef.value) return;

    const matchMedia = gsap.matchMedia();

    matchMedia.add('(min-width: 1024px)', () => {
      const cards = gsap.utils.toArray('.service-card-base');
      const finalPositions = [
        { x: 0, y: -40 },
        { x: 0, y: -40 },
        { x: 0, y: -80 },
        { x: 0, y: -80 },
        { x: 0, y: -40 }
      ];

      gsap
        .timeline({
          scrollTrigger: {
            trigger: wrapperRef.value,
            start: 'top center',
            end: '+=200%',
            scrub: 1,
            pin: false,
            markers: false
          }
        })
        .to(
          cards,
          {
            duration: 2,
            ease: 'power2.out',
            x: (i) => finalPositions[i].x,
            y: (i) => finalPositions[i].y,
            stagger: 0
          },
          0
        );
    });
  };

  onMounted(() => {
    initAnimation();
  });

  return {
    wrapperRef,
    isModalOpen,
    openModal,
    closeModal
  };
};
